module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/25.fdf6c3bd.png";